import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByIndex} from "./DashBoardResultSetUtil";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createGauge(userDashboardChartLine, h, w, widget) {
    let parameters = userDashboardChartLine.parameters;
    let chartTitle = calcChartTitle(userDashboardChartLine);
    let gaugeUnit = parameters[DashboardConstants.Param_GuageUnit];
    let gaugeBands = parameters[DashboardConstants.Param_GaugeBands];
    let values = userDashboardChartLine.resultSet;
    let split = gaugeBands.split(",");
    let min = 0;
    let max = 0;
    let bands = [];
    for (let i = 0; i < split.length; i += 3) {
        let from = parseInt(split[i]);
        if (from < min)
            min = from;
        let to = parseInt(split[i + 1]);
        if (to > max)
            max = to;
        let color = split[i + 2];
        bands.push({
            from: from,
            to: to,
            color: color
        });
    }
    let subWidget = $(`<div id = "gaugeContainer"><center>${chartTitle}</center><div id="gauge"></div><div id="val" class="gaugeVal"></div></div>`);
    widget.append(subWidget);
    widget.width(w);
    widget.height(h);
    let value = getByIndex(0, 0, values);
    widget.find("#gauge").kendoRadialGauge({
        renderAs: "canvas",
        pointer: {
            value: value
        },
        scale: {
            startAngle: -30,
            endAngle: 210,
            min: min,
            max: max,
            ranges: bands
        }
    });
    widget.find("#val").text(value + "" + gaugeUnit);
    return widget;
}